/**
 * @flow
 * @relayHash 7d772a5650e91b16e3b9c009a5f7ea38
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type MusicPlannerContainer_RefetchQueryVariables = {|
  id: string
|};
export type MusicPlannerContainer_RefetchQueryResponse = {|
  +node: ?{|
    +id?: string
  |}
|};
export type MusicPlannerContainer_RefetchQuery = {|
  variables: MusicPlannerContainer_RefetchQueryVariables,
  response: MusicPlannerContainer_RefetchQueryResponse,
|};
*/


/*
query MusicPlannerContainer_RefetchQuery(
  $id: ID!
) {
  node(id: $id) {
    __typename
    ... on MusicPlanner {
      id
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "MusicPlannerContainer_RefetchQuery",
  "id": null,
  "text": "query MusicPlannerContainer_RefetchQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on MusicPlanner {\n      id\n    }\n    id\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "MusicPlannerContainer_RefetchQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "type": "MusicPlanner",
            "selections": [
              v2
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "MusicPlannerContainer_RefetchQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          },
          v2
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5b59d13c05a1351732059209cbec2403';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Document/MusicPlanner/__generated__/MusicPlannerContainer_RefetchQuery.graphql.js